import { Box, styled } from '@mui/material'

export const Pill = styled(Box)<IPillContainer>(({ theme, example, videoIndex, index }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: example?.image?.fullSize ? theme.spacing(1.5, 3, 1.5, 2.5) : theme.spacing(1.5, 2.5),
  background: '#25262E',
  borderRadius: '30px',
  cursor: 'pointer',
  filter: videoIndex === index ? 'none' : 'brightness(0.5)',
}))

export const IconContainer = styled(Box)({
  height: '24px',
  width: '24px',
  position: 'relative',
})
